export const SPLATS = [
    { id: "julien3", path: "splats/julien3.ply" },
    { id: "julien2", path: "splats/julien2.ply" },
    { id: "corridor1", path: "splats/corridor1.ply" },
    { id: "julien1", path: "splats/julien1.ply" },
    { id: "tokyo2", path: "splats/tokyo2.ply" },
];

export function getActiveSplat() {
    const hash = window.location.hash.replace(/^#/, "");
    return SPLATS.find((splat) => splat.id === hash) || SPLATS[0];
}
